<template>
  <router-link :to="go_to()" class="project link">
    <tr>
      <td :data-label="translate('project.client')" class="name">
        {{ project.client }}
      </td>
      <td :data-label="translate('project.name')" class="name">
        {{ project.name }}
      </td>
      <td :data-label="translate('project.descr')" class="name">
        {{ project.description }}
      </td>
      <td :data-label="translate('project.status')" class="w180">
        <span class="badge" :class="get_status(project.status).color">
          {{ get_status(project.status).title }}
        </span>
      </td>
      <td :data-label="translate('project.priority')" class="w180">
        <span class="badge" :class="get_priority(project.priority).color">
          {{ get_priority(project.priority).title }}
        </span>
      </td>
      <td :data-label="translate('project.updated')" class="w100">
        {{ get_date(project.ts_update, ts_date_options) }}
      </td>
    </tr>
  </router-link>
</template>
<script>

export default {
  name: 'ProjectListItem',
  components: {
  },
  props: ["project", "project_statuses", "project_prioritys"],
  data () {
    return {
      ts_date_options:{
        hour12: false,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }
    }
  },
  computed: {

  },
  activated () {

  },
  mounted () {

  },
  methods: {
    get_status(status){
      let new_status = status !== null ? status : 0
      return this.$store.getters.getProjectInfo.statuses.find((entry) => {
        if (entry.id === new_status) return entry
      })
    },
    get_priority(priority){
      let new_priority = priority !== null ? priority : 0
      return this.$store.getters.getProjectInfo.prioritys.find((entry) => {
        if (entry.id === new_priority) return entry
      })
    },
    go_to() {
      return { path: '/project/' + this.project.id }
    },

  }
}
</script>

<style lang="scss" scoped>
.project{
  cursor: pointer;
  color: #252422;
  &:hover{
    background-color: #eee;
  }
  td{
    overflow: hidden;
  }
  .level{
    display: inline-block;
    width: 20px;
    height: 100%;
  }
  .w180{
    max-width: 180px;
    width: 180px;
  }
  .w100{
    max-width: 100px;
    width: 100px;
  }
  .has_child{
    background-color: #eee;
    font-weight: bold;
  }
  .name{
    text-align: left;
  }
  .inn{
    text-align: left;
  }
}
</style>
